import { Component, input } from '@angular/core';
import { Parcel } from 'app/core/app.model';
import { Branding } from 'app/core/auth/user.model';
import { ReportTitle } from 'app/core/report/report.model';
import { CoverDefaultComponent } from './cover-default.component';
import { CoverImageComponent } from './cover-image.component';
import { CoverModernComponent } from './cover-modern.component';


@Component({
    selector: 'report-cover-preview',
    imports: [
        CoverImageComponent,
        CoverDefaultComponent,
        CoverModernComponent,
    ],
    styles: [
        `
        :host {
            display: block;
        }
        `
    ],
    template: `
        <cover-image>
            @if (branding()?.style === 'modern') {
                <cover-modern
                    [title]="title()"
                    [parcel]="parcel()"
                    [createdAt]="createdAt"
                    [creaTrademarkStatement]="creaTrademarkStatement()"
                    [image]="image()"
                    [branding]="branding()"
                    [showGoogleImages]="showGoogleImages()">
                </cover-modern>
            }
            @else {
                <cover-default
                    [title]="title()"
                    [parcel]="parcel()"
                    [createdAt]="createdAt"
                    [creaTrademarkStatement]="creaTrademarkStatement()"
                    [image]="image()"
                    [branding]="branding()"
                    [showGoogleImages]="showGoogleImages()">
                </cover-default>
            }
        </cover-image>
    `,
})
export class CoverPreviewComponent {

    createdAt: string = new Date().toString();

    title = input.required<ReportTitle>();

    creaTrademarkStatement = input<string | null>(null);

    parcel = input.required<Parcel>();

    image = input<string | null>(null);

    branding = input.required<Branding | null>();

    showGoogleImages = input(true);
}
